"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeMembers_en_us = void 0;
function backofficeMembers_en_us() {
    return {
        "backoffice.members.name": "Co-Worker",
        "backoffice.members.roles": "Roles",
        "backoffice.members.companyroles": "Company Roles",
        "backoffice.members.projectroles": "Project Roles",
        "backoffice.members.addrole": "Add Role",
        "backoffice.members.addroletext": "Add ${name}",
        "backoffice.members.roleadded": "Role added to user",
        "backoffice.members.actions": "Actions",
        "backoffice.members.project.members": "Project Members",
        "backoffice.members.project.subtitle": "Here you can edit the permission roles of other project members.",
        "backoffice.members.company.members": "Company Members",
        "backoffice.members.company.subtitle": "Here you can edit the permission roles of other company members."
    };
}
exports.backofficeMembers_en_us = backofficeMembers_en_us;
